export default {
  tasks: [],
  pagination: {},
  contacts: [],
  paginationC: {},
  task: {}
}
